export default {"src":"/_next/static/media/facebook_icon.bd08c641.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};